import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import { X } from 'lucide-react';
import StripePaymentButton from './StripePaymentButton';
import './PaymentModal.css';

const PaymentModal = ({ open, onClose }) => {
  const closeButtonRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    closeButtonRef.current?.focus();

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') onClose();
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.body.style.overflow = previousOverflow;
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [open, onClose]);

  if (!open) return null;

  return createPortal(
    <div className="payment-modal" onClick={onClose}>
      <div
        className="payment-modal-content"
        role="dialog"
        aria-modal="true"
        aria-labelledby="payment-modal-title"
        aria-describedby="payment-modal-description"
        onClick={(event) => event.stopPropagation()}
      >
        <button
          ref={closeButtonRef}
          type="button"
          className="payment-modal-close"
          aria-label="Close payment dialog"
          onClick={onClose}
        >
          <X size={22} aria-hidden="true" />
        </button>
        <h2 id="payment-modal-title">Make A Payment</h2>
        <p id="payment-modal-description">Submit your housing payment securely online.</p>
        <StripePaymentButton className="payment-modal-stripe-button" />
      </div>
    </div>,
    document.body
  );
};

export default PaymentModal;
